import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/hxzg_bg1.png';
const _withScopeId = n => (_pushScopeId("data-v-59da6efa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding": "16px",
    "font-size": "14px !important",
    "background-color": "white"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "flex-shrink": "0",
    "height": "100%"
  }
}, null, -1));
const _hoisted_3 = [_hoisted_2];
import bkImg1 from "@/assets/img/hxzg_bg1.png";
import bkImg2 from "@/assets/img/hxzg_bg2.png";
import bkImg3 from "@/assets/img/hxzg_bg3.png";

import { reactive } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const imgList = reactive([{
      url: bkImg1
    }, {
      url: bkImg2
    }, {
      url: bkImg3
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
    };
  }
});